/* global Modernizr */

import throttle from '../helpers/throttle';

const $window = $(window);
const $header = $('.header');

const header = {
  initialize() {
    if ($header.length) {
      this.createEvents();
    }
  },

  createEvents() {
    const throttledScroll = throttle(this.scroll.bind(this), 40);

    $('.js-header-openable > a, .js-header-openable > button').on('click', (e) => {
      if (Modernizr.touchevents) {
        e.preventDefault();
        const $el = $(e.currentTarget).parent();
        const isOpen = $el.hasClass('is-open');

        $el.toggleClass('is-open', !isOpen);
      }
    });

    $('body').on('touchend', (e) => {
      const $el = $(e.target);
      const $parentOpenable = $el.parents('.js-header-openable');

      if (!$parentOpenable.length) {
        $('.js-header-openable.is-open').removeClass('is-open');
      }
    });

    $window.on('scroll', () => {
      throttledScroll();
    });
  },

  scroll() {
    const top = $window.scrollTop();

    if (top > 0 && !$header.hasClass('is-scrolled')) {
      $header.addClass('is-scrolled');
    } else if (top <= 0 && $header.hasClass('is-scrolled')) {
      $header.removeClass('is-scrolled');
    }
  },
};

export default header;
